import { Component, AfterViewInit, OnInit, Input, OnChanges, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Farm } from 'src/app/shared/dtos/Farm';
import * as L from 'leaflet';
import 'leaflet-draw';
import * as turf from '@turf/turf';
import { MapService } from '../map.service';
import { MapStyleService } from '../map-style.service';
import { Router } from '@angular/router';
import { FarmService } from '../farm.service';
import { icon, Marker } from 'leaflet';
import { Observable } from 'rxjs/Observable';
import { TownHall } from 'src/app/shared/dtos/TownHall';
import { Subscription } from 'rxjs';
import { Municipality } from 'src/app/shared/dtos/Municipality';

@Component({
  selector: 'app-map-farms',
  templateUrl: './map-farms.component.html',
  styleUrls: ['./map-farms.component.css']
})
export class MapFarmsComponent implements AfterViewInit, OnInit, OnChanges, OnDestroy {

  private readonly MAP_ID = 'map';

  @Input() allFarms: Farm[];
  private map: any;
  private popup: L.popup;
  isEdition: true;
  pointsFarmsCenter;
  farmsSelected;
  layerFarms: L.layer;
  layerMarkerFarms: L.layer;
  showPopup = false;
  featureCollection: L.feature [] = [];
  paramsPopup: any;
  townHallSelected$: Observable<TownHall>;
  municipalitySelected$: Observable<Municipality>;
  latitude ='';
  longitude ='';
  subscription: Subscription;

  @ViewChild('popup', { static: false }) popupContent: ElementRef;

  selectedFeature: any;

  constructor(private mapService: MapService, private mapStyleService: MapStyleService, 
    private router: Router, private farmService: FarmService) { }

  ngAfterViewInit(): void {
    this.initializeMap();
    // L.control.layers(this.mapService.getBaseLayers()
    // , this.mapService.getOverLayers(), { collapsed: false }).addTo(this.map);
  }

  initializeMap(){
    this.map = L.map(this.MAP_ID, this.mapService.getDefaultMapOptions());
    L.control.layers(this.mapService.getBaseLayers(), this.mapService.getOverLayers(), { collapsed: false }).addTo(this.map);
    const layer = this.mapService.getBaseLayers()['Mapa mundo'];
    layer.addTo(this.map);

    // this.configureDefaultLayers();
    this.map.on('zoomend', () => this.onZoomInMap());
    this.popup = L.popup({width: 40});
    // this.mapService.getPosition().then(pos=>
    //   {
    //      this.map.flyTo(new L.latLng(pos.lat,pos.lng),14);
    //   });
  }

  ngOnInit(): void {
    this.townHallSelected$ = this.mapService.getLocationSelected();
    this.municipalitySelected$ = this.mapService.getLocationPortugalSelected();
    this.subscription = this.townHallSelected$.subscribe(townHall => {
      this.latitude = townHall.latitude;
      this.longitude = townHall.longitude;
    });
    this.subscription = this.municipalitySelected$.subscribe(municipality => {
      this.latitude = municipality.latitude;
      this.longitude = municipality.longitude;
    });
  }

  ngOnChanges(): void {
    if (this.allFarms !== undefined) {
      this.featureCollection = [];
      if(this.layerFarms!== undefined){
        this.map.removeLayer(this.layerFarms);
      }
      if (this.layerMarkerFarms!== undefined){
        this.map.removeLayer(this.layerMarkerFarms);
      }
      this.allFarms.map( (data) => {
        this.featureCollection.push(this.mapService.geometryToGeoJson(data.geometry, data));
      });
      this.layerFarms = L.geoJson(this.featureCollection).addTo(this.map);
      this.layerFarms.on('mouseover', (e: L.LeafletMouseEvent) => {
        this.onLayerClick(e);
      });
    }
    if (this.latitude && this.longitude){
      const centerCordinatesByParam = [];
      centerCordinatesByParam.push(parseFloat(this.latitude.replace(/,/g, '.')));
      centerCordinatesByParam.push(parseFloat(this.longitude.replace(/,/g, '.')));
      this.map.flyTo(new L.latLng(centerCordinatesByParam), 14);
    }
    
  }

  configureDefaultLayers() {
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
    L.control.layers(this.mapService.getTileLayers(), {}).addTo(this.map);
  }

  onZoomInMap() {
    if(this.featureCollection.length > 0){
      if (this.map.getZoom() < 12) {
        console.log('zoom: ', this.map.getZoom());
        this.map.removeLayer(this.layerFarms);
        if (this.layerMarkerFarms !== undefined) {
          this.map.removeLayer(this.layerMarkerFarms);
        }
        this.getPoints();
        this.layerMarkerFarms.on('click', (e: L.LeafletMouseEvent) => {
          this.onLayerClick(e);
        });
      } else {
          console.log('zoom: ', this.map.getZoom());
          if (this.layerMarkerFarms !== undefined) {
            this.map.removeLayer(this.layerMarkerFarms);
          }
            this.map.addLayer(this.layerFarms);
            this.layerFarms.on('mouseover', (e: L.LeafletMouseEvent) => {
              this.onLayerClick(e);
            });
        }
    }
  }


  onLayerClick(event: L.LeafletMouseEvent): void {
    this.paramsPopup = event.layer.feature.properties;
    this.showPopup = true;
    setTimeout(() => {
      this.popup
      .setLatLng(event.latlng)
      .setContent(this.popupContent.nativeElement)
      .openOn(this.map);
    });
  }

  getPoints() {
    const pointsMarkers = this.featureCollection.map(data => {
      return this.mapService.geometryToGeoJson(turf.pointOnFeature(data).geometry, data.properties);
    });
    const layerOptions = {
      pointToLayer: undefined
    };
    layerOptions.pointToLayer = (feature, latlng) => {
      this.mapStyleService.getIconMarker();
      return L.marker(latlng);
    }
    this.layerMarkerFarms = L.geoJson(pointsMarkers, layerOptions).addTo(this.map);

  }

  onClickToFarm(event, idFarm: number){
    this.router.navigate(['particular-farm/' + idFarm]);
  }

  getUrlImage(url: string) {
    return this.farmService.getUrlImage(url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

